/**
 * Default color presets used for background and corresponding text color.
 * Each color object includes the background color (`value`),
 * recommended text color (`textColor`), and optional `default` flag.
 *
 * @typedef {Object} ColorPreset
 * @property {string} value - Background color in hex format (e.g., '#ffffff').
 * @property {string} textColor - Recommended text color in hex format.
 * @property {boolean} [default] - Whether this color is the default selection.
 */

/** @type {ColorPreset[]} */
export const defaultColors = [
  {
    value: '#ffffff',
    textColor: '#000000',
    default: true,
  },
  {
    value: '#000000',
    textColor: '#ffffff',
  },
  {
    value: '#de4d44',
    textColor: '#000000',
  },
  {
    value: '#9e3744',
    textColor: '#ffffff',
  },
  {
    value: '#ff842a',
    textColor: '#000000',
  },
  {
    value: '#fc766a',
    textColor: '#000000',
  },
  {
    value: '#c83e74',
    textColor: '#ffffff',
  },
  {
    value: '#8d9440',
    textColor: '#000000',
  },
  {
    value: '#fed65e',
    textColor: '#000000',
  },
  {
    value: '#2e5d9f',
    textColor: '#ffffff',
  },
  {
    value: '#755841',
    textColor: '#ffffff',
  },
  {
    value: '#daa03d',
    textColor: '#000000',
  },
  {
    value: '#616247',
    textColor: '#ffffff',
  },
  {
    value: '#e7b7cf',
    textColor: '#000000',
  },
  {
    value: '#d7c49e',
    textColor: '#000000',
  },
  {
    value: '#3b3a50',
    textColor: '#ffffff',
  },
  {
    value: '#f2edd7',
    textColor: '#000000',
  },
  {
    value: '#615550',
    textColor: '#ffffff',
  },
];
